import "core-js/modules/es.array.index-of";
import * as logger from 'universal-logger';
var RESET_ERROR = 'classpass/error/RESET';
export var resetError = function resetError() {
  return {
    type: RESET_ERROR
  };
};
export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var shouldThrowErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __SERVER__;
  var type = action.type,
      error = action.error;

  if (type === RESET_ERROR) {
    return null;
  } else if (error && type.indexOf('@@redux-form') === -1) {
    logger.error(error);

    if (!action.suppressGlobalErrorHandling) {
      if (shouldThrowErrors && !action.fromClientMiddleware) {
        throw error;
      }

      return {
        message: typeof error === 'string' ? error : error.message,
        details: error && error.details,
        code: error && error.code,
        httpStatus: error && error.httpStatus
      };
    }
  }

  return state;
}